import React from 'react';

const ProgressBar = ({ value, className }) => {
  return (
    <div className={`w-full h-3 bg-blueSoft ${className}`}>
      <div className={`h-full bg-tealLight transition-all ${className}`} style={{ width: `${value}%` }}></div>
    </div>
  );
};

export default ProgressBar;
